import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { useCartRedux } from '@hooks'

const InventoryWarningModal = ({ isOpen, isProcessing, onCancel, onConfirm, inventoryChanges }) => {
    const { items } = useCartRedux()
    const { soldOutItems, checkAvailableItems } = inventoryChanges

    return (
        <Modal isOpen={isOpen} toggle={onCancel}>
            <ModalHeader toggle={onCancel}>Inventory Status Update</ModalHeader>
            <ModalBody>
                {soldOutItems?.length > 0 && (
                    <div className="mb-4">
                        <h3 className="text-danger fw-bold mb-2">Sold Out Items (Removed From Cart)</h3>
                        <ul className="ps-4">
                            {soldOutItems.map((item, idx) => (
                                <li key={idx} className="text-secondary">
                                    {item.type === 'variant' ?
                                        `${item.itemName} ${item.name === 'Default Title' ? '' : `- ${item.name}`} (${item.stallName})`
                                    :   `${item.itemName} - ${item.selectionName} - ${item.name} (${item.stallName})`}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                {checkAvailableItems?.length > 0 && (
                    <div>
                        <h3 className="text-warning fw-bold mb-2">Items Needing Availability Check</h3>
                        <ul className="ps-4">
                            {checkAvailableItems.map((item, idx) => (
                                <li key={idx} className="text-secondary">
                                    {item.type === 'variant' ?
                                        `${item.itemName} - ${item.name} (${item.stallName})`
                                    :   `${item.itemName} - ${item.selectionName} - ${item.name} (${item.stallName})`}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                <div className="mt-4 text-secondary">
                    Please confirm availability of the above item(s) with the respective stall(s) before continuing to checkout.
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={onCancel}>
                    Add More Items
                </Button>
                {items.length > 0 && (
                    <Button color="primary" onClick={onConfirm} disabled={isProcessing}>
                        Continue Checkout
                    </Button>
                )}
            </ModalFooter>
        </Modal>
    )
}

export default InventoryWarningModal
